import { render, staticRenderFns } from "./Crm.vue?vue&type=template&id=028c54d3&scoped=true&"
import script from "./Crm.ts?vue&type=script&lang=ts&"
export * from "./Crm.ts?vue&type=script&lang=ts&"
import style0 from "./Crm.vue?vue&type=style&index=0&id=028c54d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c54d3",
  null
  
)

export default component.exports